import React, { Suspense } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { NavigationContainer, useNavigation } from '@react-navigation/native';
import { AppDownloadBanner } from './components/AppDownloadBanner';
import { MainScreen } from './screens/MainScreen';
import type { ScreenItem } from 'shared/src/types';
import { MarketScreens } from 'market/src/Navigator';
import { GoodsScreens } from 'goods/src/Navigator';
import { MyPageScreens } from 'mypage/src/Navigator';
import { ScreensPageScreens } from 'screens/src/Navigator';
import { ModalProvider } from '@banhala/ui-kit';
import uuid from 'react-native-uuid';
import { ErrorBoundary } from 'shared/src/component';
import { LoadingView } from 'ably-app/src/components/LoadingView';
const Stack = createNativeStackNavigator();

const screenMetadata: ScreenItem[] = [
  ...MarketScreens,
  ...GoodsScreens,
  ...MyPageScreens,
  ...ScreensPageScreens,
];

export const NavigationWithModalProvider = () =>{
  return  (
  <NavigationContainer
    linking={{
      config: {
        screens: {
          main: {
            path: '/',
          },
          ...screenMetadata.reduce((acc, cur) => {
            return {
              ...acc,
              [cur.name]: cur.path,
            };
          }, {}),
        },
      },
      prefixes: ['https://mobile.a-bly.com'],
    }}
  >
    <AsyncErrorBoundary>
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
      screenLayout={({ children }) => {
        return (
          <ModalProvider>
            <AppDownloadBanner />
            {children}
          </ModalProvider>
        );
      }}
    >
      <Stack.Screen name={'main'} component={MainScreen} />
      {screenMetadata.map(screen => {
        return (
          <Stack.Screen
            name={screen.name}
            component={screen.component}
            options={screen.options}
            initialParams={
              screen.name === 'Screens' ? { instanceId: uuid.v4() } : {}
            }
          />
        );
      })}
    </Stack.Navigator>
    </AsyncErrorBoundary>
  </NavigationContainer>

)};


const AsyncErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const navigator = useNavigation();
  return (
    <ErrorBoundary navigation={navigator}>
      <Suspense fallback={<LoadingView />}>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};